(function () {
  const STYLE_ID = 'gekkeikan-shop-follow-style';
  const BUTTON_CSS = `
    :host {
      --shopify-login-button-background: #201818 !important;
      --shopify-login-button-color: #ffffff !important;
      --shopify-login-button-border-color: #201818 !important;
    }

    button,
    a,
    .button,
    .follow-icon-wrapper,
    .follow-icon-wrapper::before,
    .follow-icon-wrapper:before,
    .follow-text {
      background: #201818 !important;
      border-color: #201818 !important;
      color: #ffffff !important;
      box-shadow: none !important;
    }

    button,
    a,
    .button,
    .follow-icon-wrapper {
      border-radius: 2px !important;
    }

    .follow-text,
    .follow-text *,
    button,
    button *,
    a,
    a * {
      color: #ffffff !important;
      font-family: inherit !important;
      font-weight: 800 !important;
      letter-spacing: 0.06em !important;
      text-transform: uppercase !important;
    }

    button:hover,
    button:focus,
    a:hover,
    a:focus,
    .follow-icon-wrapper:hover,
    .follow-icon-wrapper:hover::before,
    .follow-icon-wrapper:hover:before,
    .follow-icon-wrapper:hover .follow-text {
      background: #A38B78 !important;
      border-color: #A38B78 !important;
      color: #ffffff !important;
    }
  `;

  function injectStyle(root) {
    if (!root || root.querySelector(`#${STYLE_ID}`)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = BUTTON_CSS;
    root.appendChild(style);
  }

  function styleShopFollowButtons(root) {
    injectStyle(root);

    root.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) {
        styleShopFollowButtons(element.shadowRoot);
      }
    });
  }

  function run() {
    styleShopFollowButtons(document);
  }

  run();
  window.addEventListener('load', run);
  window.setTimeout(run, 500);
  window.setTimeout(run, 1500);

  const observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
